import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../layout/layout.service';
import { ValidationMessage } from 'app/validation';
import { ProgramService } from 'app/client-core/services/program.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-distribute-delivery',
  templateUrl: './distribute-delivery.component.html',
  styleUrls: ['./distribute-delivery.component.scss']
})
export class DistributeDeliveryComponent implements OnInit {
  ready: boolean;
  public validationMessages: ValidationMessage;
  public distributionDto: any;
  public selectedProgramId: number;
  public shippingId: number;
  locations: any;

  constructor(
    private layoutService: LayoutService,
    private programService: ProgramService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  clear() {
    this.selectedProgramId = null;
    this.distributionDto = {};
  }

  init() {
    this.getDistribution();
  }

  getDistribution() {
    this.programService.getDistributionLocation(this.selectedProgramId).subscribe(response => {
      this.distributionDto = response.data;
      this.locations = this.getLocation();
      this.ready = true;
    });
  }

  closeModal() {
    this.layoutService.hideSideModal.next();
  }

  getLocation() {
    const locations = [];
    let locationsToLook = this.distributionDto.locations;
    if (this.shippingId) {
      locationsToLook = this.distributionDto.locations.filter(l => l.id == this.shippingId);
    }

    locationsToLook.forEach(loc => {
      const location = {
        ...this.distributionDto.locations.find(l => l.id == loc.id),
        tactics: []
      }

      this.distributionDto.tactics.forEach(t => {
        const l = t.locations.find(lc => lc.id == loc.id);
        if (l) {
          location.tactics.push({
            ...t,
            orderQuantity: l.distributionQuantity
          });
        }
      });

      locations.push(location)
    });
    return locations;
  }

  openDistributionModal() {
    this.router.navigateByUrl(`/tactic-catalog/${this.selectedProgramId}/finalize/distribution`);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/distribute-delivery/distribute-delivery.component.ts